export class ScoreReference {
	id: number;
	label: string;
	url: string;
}
